import { useState } from 'react';
import Hero from './components/Hero';
import Description from './components/Description';
import Purchase from './components/Purchase';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Description />
      <Purchase />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
}
